import { Card, Col, List, Radio, Row, Tooltip, Drawer, Button, Form, notification, Input, Select } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../request';
import styles from './styles.less';
import followUpsIcon from '../../assets/icons/registration/followUpsIcon.png';
import { getUrlPushWrapper } from "../../routes";
import async from 'async';
import _ from 'lodash';
import {
    FaMoneyCheckAlt,
    FaRegBuilding,
    FaUserCog
} from "react-icons/fa";
import { RightsWrapper } from '../../components/_utils/utils';
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils';
import LatestFollowup from '../../components/_utils/latestFollowup';
import PDFFileView from '../../components/DocumentViews/PDFFileView';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const Option = Select.Option
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';

const data = [
    { name: 'Group A', value: 525 },
    { name: 'Group B', value: 175 }
];

const COLORS = ['#56BFEE', '#69ccf9'];

@Form.create()

class AddUniversityCommDrawer extends Component {
    state = {
        visible: true,
        universityArr: [],
        levelOptions: [],
        loading: false,
        loadingButton: false,
        bonusAny: '',
        minimumStudents: '',
        maximumStudents: '',
        bonusType: '',
        commissionType: '',
        bonus: '',
        bonusDetails: [],
        bonusIndex: null
    }


    loadUniversities = async () => {
        let universityArr = []
        let params = {
            count: 10000,
            results: 10000
        }
        let univResponse = await Request.getNotAddedCommissionUniversity(params)
        async.each(univResponse.data, (univ) => {
            universityArr.push({ _id: univ._id, display: univ.universityInstitutionName })
        })
        this.setState({ universityArr })
    }

    addBonusCommission = () => {
        let { totalStudents, minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusDetails } = this.state;
        if (!minimumStudents || !maximumStudents) {
            notification.error({
                message: 'Min - Max Students Required'
            })
            return false;
        } else if (!bonusType) {
            notification.error({
                message: 'Bonus Type is required'
            })
            return false;
        } else if (!commissionType) {
            notification.error({
                message: 'Commission Type is required'
            })
            return false;
            // } else if(!bonus) {
            //   notification.error({
            //     message: 'Bonus is required'
            //   })
            //   return false;
        }
        bonusDetails.push({
            minimumStudents,
            maximumStudents,
            bonusType,
            commissionType,
            bonus
        })
        this.setState({
            bonusDetails: bonusDetails,
            bonusIndex: null,
            minimumStudents: null,
            maximumStudents: null,
            bonusType: null,
            commissionType: null,
            bonus: null
        });
    }
    updateBonusCommission = () => {
        let { minimumStudents, maximumStudents, bonusType, commissionType, bonus, bonusIndex, bonusDetails } = this.state;
        if (!minimumStudents || !maximumStudents) {
            notification.error({
                message: 'Min - Max Students is required'
            })
            return false;
        } else if (!bonusType) {
            notification.error({
                message: 'Bonus Type is required'
            })
            return false;
        } else if (!commissionType) {
            notification.error({
                message: 'Commission Type is required'
            })
            return false;
            // } else if(!bonus) {
            //   notification.error({
            //     message: 'Bonus is required'
            //   })
            //   return false;
        }
        if (bonusDetails[bonusIndex] !== undefined) {
            bonusDetails[bonusIndex] = {
                minimumStudents,
                maximumStudents,
                bonusType,
                commissionType,
                bonus
            };
        }
        this.setState({
            bonusDetails: bonusDetails,
            bonusIndex: null,
            totalStudents: null,
            minimumStudents: null,
            maximumStudents: null,
            bonusType: null,
            commissionType: null,
            bonus: null
        });
    }

    removeBonus = (index) => {
        let { bonusDetails } = this.state;
        if (bonusDetails[index] !== undefined) {
            bonusDetails.splice(index, 1);
        }
        this.setState({
            bonusDetails: bonusDetails
        });
    }
    editBonus = (index, bonusDetail) => {
        this.setState({
            bonusIndex: index,
            minimumStudents: bonusDetail.minimumStudents,
            maximumStudents: bonusDetail.maximumStudents,
            bonusType: bonusDetail.bonusType,
            commissionType: bonusDetail.commissionType,
            bonus: bonusDetail.bonus
        });
    }

    loadLevels = async () => {
        let params = { sortField: 'levelName', sortOrder: 'ascend' }
        Request.loadSimpleLevels({ ...params })
            .then(resp => {
                let temp = [{ display: '---Select All---', id: 'all' }];
                resp.data = resp.data.reduce((el, vv) => {
                    temp.push({ _id: vv._id, display: vv.levelName })
                    return temp
                }, [])
                this.setState({ levelOptions: resp.data })
            })
            .catch(err => {
                console.log(err)
            })
    }

    getDetails = () => {
        let { recordId } = this.props;
        setTimeout(() => {
            this.props.form.setFieldsValue({ universityId: recordId })
        }, 800)
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    async componentDidMount() {
        this.setState({ loading: true })
        await this.loadUniversities();
        await this.loadLevels();
        await this.getDetails();
        this.setState({ loading: false })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            values.bonusAny = (values.bonusAny ? values.bonusAny : 'No');
            values.bonusDetails = this.state.bonusDetails;
            this.setState({ loadingButton: true })
            let x = await Request.addUniversityCommission(values);
            this.setState({ loadingButton: false })
            if (x.success) {
                notification.success({
                    message: x.msg
                })
            } else {
                notification.error({
                    message: x.msg
                })
            }
            this.onClose()
        })
    }

    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let { visible, universityArr, levelOptions, loading, bonusIndex, bonusAny, bonusDetails, bonusType } = this.state

        let inputTypes = {
            fields: [
                {
                    label: 'University',
                    key: 'universityId',
                    type: 'select',
                    required: true,
                    disabled: true,
                    showSearch: true,
                    options: universityArr,
                    onChange: v => {
                        setFieldsValue({ universityId: v })
                    }
                },
                {
                    label: 'Course Level',
                    key: 'courseLevelId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    mode: 'multiple',
                    disabled: false,
                    options: levelOptions,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === levelOptions.length) {
                                val = [];
                            } else {
                                val = levelOptions.slice(1).map(levelOption => levelOption._id);
                            }
                        }
                        this.props.form.setFieldsValue({
                            courseLevelId: val
                        })
                    }
                },
                {
                    label: 'No Of Invoices',
                    key: 'noOfInvoice',
                    type: 'select',
                    required: true,
                    disabled: false,
                    options: [
                        1, 2, 3, 4, 5, 6
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            noOfInvoice: v
                        })
                    }
                },
                {
                    label: 'Invoice Per Year',
                    key: 'invoicePerYear',
                    type: 'select',
                    required: true,
                    disabled: false,
                    options: [
                        0, 1, 2, 3, 4, 5, 6
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            invoicePerYear: v
                        })
                    }
                },
                {
                    label: 'Commission Type',
                    key: 'commissionTypeFrom',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Flat', 'Percentage'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            commissionTypeFrom: v
                        })
                    }
                },
                {
                    label: 'Commission Amount / %',
                    key: 'commissionFromUniversity',
                    required: true
                },
                {
                    label: 'Bonus If any',
                    key: 'bonusAny',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Yes', 'No'
                    ],
                    onChange: v => {
                        this.setState({ bonusAny: v });
                        this.props.form.setFieldsValue({
                            bonusAny: v
                        })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Add University Commission
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            apiurl={LAPI_URL}
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                            loading={loading}
                        />
                        {
                            bonusAny == 'Yes' ?
                                <div>
                                    <Card title="Bonus Details">
                                        <div>
                                            <Row>
                                                <Col span={3}>
                                                    <label>Min Students</label>
                                                    <Input type={'number'}
                                                        placeholder={"Minimum"}
                                                        value={this.state.minimumStudents}
                                                        onChange={(ei) => {
                                                            this.setState({ minimumStudents: ei.target.value });
                                                        }} />
                                                    {/* <label>Total Students</label>
                              <Input
                                type={'number'}
                                placeholder={"Total Students"}
                                value={this.state.totalStudents}
                                onChange={(ei) => {
                                  this.setState({ totalStudents: ei.target.value });
                                }}
                              /> */}
                                                </Col>
                                                <Col span={3}>
                                                    <label>Max Students</label>
                                                    <Input type={'number'}
                                                        placeholder={"Minimum"}
                                                        value={this.state.maximumStudents}
                                                        onChange={(ei) => {
                                                            this.setState({ maximumStudents: ei.target.value });
                                                        }} />
                                                    {/* <label>Total Students</label>
                              <Input
                                type={'number'}
                                placeholder={"Total Students"}
                                value={this.state.totalStudents}
                                onChange={(ei) => {
                                  this.setState({ totalStudents: ei.target.value });
                                }}
                              /> */}
                                                </Col>
                                                <Col span={5}>
                                                    <label>Bonus Type</label>
                                                    <Select
                                                        placeholder="Select Bonus Type"
                                                        showSearch={true}
                                                        value={
                                                            this.state.bonusType
                                                        }
                                                        onChange={(ei) => {
                                                            this.setState({
                                                                bonusType: ei
                                                            });
                                                        }}
                                                    >
                                                        <Option value={'Per Student'}> Per Student </Option>
                                                        <Option value={'Total Student'}> Total Student </Option>
                                                    </Select>
                                                </Col>
                                                <Col span={5}>
                                                    <label>Commission Type</label>
                                                    <Select
                                                        placeholder="Select Commission Type"
                                                        showSearch={true}
                                                        value={
                                                            this.state.commissionType
                                                        }
                                                        onChange={(ei) => {
                                                            this.setState({
                                                                commissionType: ei
                                                            });
                                                        }}
                                                    >
                                                        <Option value={'flat'}> Flat </Option>
                                                        <Option value={'percantage'}> Percantage </Option>
                                                    </Select>
                                                </Col>
                                                <Col span={5}>
                                                    <label>Commission</label>
                                                    <Input
                                                        type={'Bonus'}
                                                        placeholder={"Bonus"}
                                                        value={this.state.bonus}
                                                        onChange={(ei) => {
                                                            this.setState({ bonus: ei.target.value });
                                                        }}
                                                    />
                                                </Col>
                                                <Col span={2}>
                                                    <label>&nbsp;&nbsp;&nbsp;</label>
                                                    {
                                                        bonusIndex != null ?
                                                            <Button
                                                                type="primary"
                                                                style={{ marginBottom: 10, marginLeft: '1%' }}
                                                                loading={this.props.loading}
                                                                onClick={() => {
                                                                    this.updateBonusCommission()
                                                                }}>
                                                                Update
                                                            </Button>
                                                            :
                                                            <Button
                                                                type="primary"
                                                                style={{ marginBottom: 10, marginLeft: '1%' }}
                                                                loading={this.props.loading}
                                                                onClick={() => {
                                                                    this.addBonusCommission()
                                                                }}>
                                                                Add
                                                            </Button>
                                                    }

                                                </Col>
                                            </Row>
                                            <Row>
                                                <Card title="Bonus List">
                                                    <table className="table-bonus-list">
                                                        <thead>
                                                            <tr>
                                                                {/* <th>Total Students</th> */}
                                                                <th>Min - Max Students</th>
                                                                {/* <th>Maximum</th> */}
                                                                <th>Bonus Type</th>
                                                                <th>Commission Type</th>
                                                                <th>Bonus</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bonusDetails && bonusDetails.map((bonusDetail, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{`${bonusDetail.minimumStudents} - ${bonusDetail.maximumStudents}`}</td>
                                                                            {/* <td>{bonusDetail.totalStudents}</td> */}
                                                                            {/* <td>{bonusDetail.minimum}</td>
                                          <td>{bonusDetail.maximum}</td> */}
                                                                            <td>{bonusDetail.bonusType}</td>
                                                                            <td>{bonusDetail.commissionType}</td>
                                                                            <td>{bonusDetail.bonus}</td>
                                                                            <td><a onClick={() => this.editBonus(index, bonusDetail)}>Edit</a> | <a onClick={() => this.removeBonus(index)}>Remove</a></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </Card>
                                            </Row>
                                        </div>
                                    </Card>
                                </div>
                                : null
                        }
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loadingButton}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class NotAddedUniversityCommission extends Component {
    state = {
        visible: true,
        count: 0,
        countriesArr: [],
        showAddUniversityComm: false,
        recordId: '',
        loading: false,
        exportParams: {},
        exportLoading: false
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }


    addUniversityCommDrawer = (recordId) => {
        this.setState({ showAddUniversityComm: true, recordId: recordId }, () => {
            this.table.current.reload()
        })
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true, exportParams: params })
            let response = await Request.getNotAddedCommissionUniversity(params);
            this.setState({ count: response.total, loading: false })
            resolve(response)
        })
    }

    exportNotAddedCommissionExcel = async () => {
        let { exportParams } = this.state;
        this.setState({ exportLoading: true });
        let response = await Request.exportNotAddedCommissionUniversities(exportParams);
        this.setState({ exportLoading: false });
        if (!response.error) {
            window.open(response.url)
        }
    }

    loadCountries = async () => {
        let countriesArr = []
        let params = {
            count: 1000,
            results: 1000,
            businessId: activeUser && activeUser.businessId
        }
        let response = await Request.getCountriesWithoutAuth(params)
        async.each(response.data, (country) => {
            countriesArr.push({ value: country.countryName, text: country.countryName })
        })
        this.setState({ countriesArr })
    }

    componentDidMount() {
        this.loadCountries()
    }

    closeUniversityCommDrawer = () => {
        this.setState({ showAddUniversityComm: false, recordId: '' }, () => {
            this.table.current.reload()
        })
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { visible, count, countriesArr, showAddUniversityComm, recordId, loading } = this.state;
        const columns = [
            {
                title: 'Sr No.',
                key: 'serial Number',
                width: 70,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                width: 70,
                render: (text, record) => (
                    <Tooltip title="Add University Commission">
                        <Button size='small' shape='circle' icon='plus' onClick={() => this.addUniversityCommDrawer(record._id)}></Button>
                    </Tooltip>
                )
            },
            {
                title: "University",
                key: "universityInstitutionName",
                width: 210,
                dataIndex: "universityInstitutionName",
                sorter: true,
                searchTextName: "universityInstitutionName",
                filterRegex: true
            },
            {
                title: "Country",
                key: 'universityCountryName',
                dataIndex: 'universityCountryName',
                width: 120,
                filters: countriesArr,
                filterRegex: true
            },
            {
                title: 'University Partnership',
                key: 'universityPartnership',
                dataIndex: 'universityPartnership',
                width: 120,
                filters: [{ value: 'TPSC INC-Direct', text: 'TPSC INC-Direct' }, { value: 'Direct', text: 'Direct' }, { value: 'Channel Partner', text: 'Channel Partner' }]
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Not Added University Commissions - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={800}
                visible={visible}
            >
                <Card>
                    {
                        showAddUniversityComm ?
                            <AddUniversityCommDrawer recordId={recordId} onClose={this.closeUniversityCommDrawer} />
                            : null
                    }
                    <RightsWrapper myRight={"commissionNotAddedUniversities.view"}>
                        <Button type='primary' loading={this.state.exportLoading} onClick={() => this.exportNotAddedCommissionExcel()}>Export Excel</Button>
                    </RightsWrapper>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}

class AddedUniversityCommissions extends Component {
    state = {
        visible: true,
        count: 0,
        loading: false
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true })
            let response = await Request.getCommissionUniversities(params);
            this.setState({ loading: false })
            this.setState({ count: response.total })
            resolve(response)
        })
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { visible, count, loading } = this.state;
        const columns = [
            {
                title: 'Sr No.',
                key: 'serial Number',
                width: 70,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: "University",
                key: "universityInstitutionName",
                width: 210,
                dataIndex: "universityInstitutionName",
                sorter: true,
                searchTextName: "universityInstitutionName",
                filterRegex: true,
            },
            {
                title: 'Commission',
                key: 'commissionFromUniversity',
                width: 100,
                dataIndex: 'commissionFromUniversity',
                searchTextName: "universityInstitutionName",
                filterRegex: true,
            },
            {
                title: "Country",
                key: 'universityId.universityCountryName',
                dataIndex: 'universityId.universityCountryName',
                width: 120
            },
            {
                title: 'Commission Type',
                key: 'commissionTypeFrom',
                dataIndex: 'commissionTypeFrom',
                width: 120,
                filters: [{ value: 'Percentage', text: 'Percentage' }, { value: 'Flat', text: 'Flat' }]
            },
            {
                title: 'Status',
                key: 'status',
                dataIndex: 'status',
                width: 120,
                filters: [{ value: 'Active', text: 'Active' }, { value: 'Inactive', text: 'Inactive' }, { value: 'Pending', text: 'Pending' }],
                filterRegex: true
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Added University Commissions - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}
            >
                <Card>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}


class TutionFeeUpdateRequest extends Component {
    state = {
        visible: true,
        count: 0,
        loading: false,
        ext: null,
        linkUrl: null,
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }


    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            this.setState({ loading: true })
            let response = await Request.getTutionFeeUpdateRequests(params);
            this.setState({ loading: false })
            this.setState({ count: response.total });
            return resolve(response);
        })
    }

    viewPDF = (file) => {
        if (file && file.url) {
            let linkUrl = MEDIA_URL + file.url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }

    updateRequest = async (recordId, status) => {
        let response = await Request.updateTutionFeeRequest({ _id: recordId, status });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.table.current.reload();
    }


    render() {
        let { visible, count, loading, ext, linkUrl } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <>
                        <Tooltip title="Approve">
                            <Button size='small' icon='check' shape='circle' onClick={() => this.updateRequest(record._id, 'Approve')} />
                        </Tooltip>
                        <Tooltip title="DisApprove">
                            <Button size='small' icon='cross' shape='circle' onClick={() => this.updateRequest(record._id, 'Disapprove')} />
                        </Tooltip>
                    </>
                )
            },
            {
                title: 'Course Name',
                key: 'courseName',
            },
            {
                title: 'University Name',
                key: 'universityInstitutionName'
            },
            {
                title: 'Current Tution Fee',
                key: 'oldTutionFee',
            },
            {
                title: 'New Tution Fee',
                key: 'updatedTutionFee'
            },
            {
                title: 'Offer Letter',
                key: 'file',
                render: (text, record) => (
                    record && record.file && record.file.url ? (
                        <Button
                            icon='eye'
                            title='View File'
                            onClick={() => this.viewPDF([record.file])} // wrap in array
                        />
                    ) : null
                )
            }
        ];
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Tution Fee Update Requests - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1000}
                visible={visible}
            >
                {
                    ext != null && linkUrl != null ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                <Card>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        loading={loading}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </Drawer>
        )
    }
}



class RelationShipManagerDashboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            drawer: false,
            drawerParam: {},
            allUniversityCount: {
                total: 0
            },
            expiryDateMissingCount: {
                total: 0
            },
            missingAgreementFileCount: {
                total: 0
            },
            renewalExpiredCount: {
                total: 0
            },
            renewalTodayCount: {
                total: 0
            },
            renewalUpcomingCount: {
                total: 0
            },
            updateTutionFeeCount: {
                total: 0
            },
            commissionNotAddedUniversitiesCounts: 0,
            commissionAddedUniversitiesCounts: 0,
            showAddedCommission: false,
            showNotAddedCommission: false,
            universityPartnerShipCount: [],
            universityConsortiumIdCounts: [],
            showUpdateTutionFeeRequest: false,
        }
    }

    async componentDidMount() {
        this.loadAllApis();
    }

    closeUniversityCommissionDrawer = () => {
        this.setState({ showAddedCommission: false, showNotAddedCommission: false }, () => {
            this.loadAllApis()
        })
    }

    loadAllApis = () => {
        Request.getRelationShipGraphData().then(({ allUniversityCount, expiryDateMissingCount, missingAgreementFileCount, renewalExpiredCount, renewalTodayCount, renewalUpcomingCount, universityPartnerShipCount, universityConsortiumIdCounts, commissionAddedUniversitiesCount, commissionNotAddedUniversitiesCount, updateTutionFeeCount }) => {
            this.setState({ allUniversityCount, expiryDateMissingCount, missingAgreementFileCount, renewalExpiredCount, renewalTodayCount, renewalUpcomingCount, universityPartnerShipCount, universityConsortiumIdCounts, commissionAddedUniversitiesCounts: commissionAddedUniversitiesCount, commissionNotAddedUniversitiesCounts: commissionNotAddedUniversitiesCount.total, updateTutionFeeCount })
        });
    }

    componentWillReceiveProps(props) {
        const { timer } = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const { dispatch } = this.props;
        let { allUniversityCount, showUpdateTutionFeeRequest, loading, showAddedCommission, showNotAddedCommission, expiryDateMissingCount, commissionAddedUniversitiesCounts, commissionNotAddedUniversitiesCounts, missingAgreementFileCount, renewalExpiredCount, renewalTodayCount, renewalUpcomingCount, universityPartnerShipCount, universityConsortiumIdCounts, updateTutionFeeCount } = this.state;
        return (
            <div>
                <div className="site-card-wrapper">
                    <RightsWrapper myRight={"relationshipAgreementCount.view"} >
                        {
                            showAddedCommission ?
                                <AddedUniversityCommissions onClose={this.closeUniversityCommissionDrawer} />
                                : null
                        }
                        {
                            showNotAddedCommission ?
                                <NotAddedUniversityCommission onClose={this.closeUniversityCommissionDrawer} />
                                : null
                        }
                        {
                            showUpdateTutionFeeRequest ?
                                <TutionFeeUpdateRequest onClose={() => this.setState({ showUpdateTutionFeeRequest: false }, () => this.loadAllApis())} />
                                : null
                        }
                        <Row>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-1 elevation-1"><FaMoneyCheckAlt /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">All University</span>
                                        <span className="info-box-number">
                                            <a href='/agreement-management?type=all' target='_blank'>
                                                {allUniversityCount.total}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Expiry Date Missing Count </span>
                                        <span className="info-box-number">
                                            <a href='/agreement-management?type=missingDateExpiry' target='_blank'>
                                                {expiryDateMissingCount.total}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Missing Agreement Count </span>
                                        <span className="info-box-number">
                                            <a href='/agreement-management?type=missingAgreement' target='_blank'>
                                                {missingAgreementFileCount.total}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-1 elevation-1"><FaMoneyCheckAlt /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Commission Added Count</span>
                                        <span className="info-box-number">
                                            <a onClick={() => {
                                                this.setState({ showAddedCommission: true })
                                            }} target='_blank'>
                                                {commissionAddedUniversitiesCounts}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Missing Commission Count </span>
                                        <span className="info-box-number">
                                            <a onClick={() => {
                                                this.setState({ showNotAddedCommission: true })
                                            }} target='_blank'>
                                                {commissionNotAddedUniversitiesCounts}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8} style={{ padding: '10px' }}>
                                <div className="info-box">
                                    <span className="info-box-icon bg-color-2 elevation-1"><FaRegBuilding /></span>
                                    <div className="info-box-content">
                                        <span className="info-box-text">Tution Fee Update Requests </span>
                                        <span className="info-box-number">
                                            <a onClick={() => {
                                                this.setState({ showUpdateTutionFeeRequest: true })
                                            }} target='_blank'>
                                                {updateTutionFeeCount.total}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </RightsWrapper>
                    <RightsWrapper myRight={"relationshipUniversityTotalExpiration.view"}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Card title={
                                    <span>
                                        <img src={followUpsIcon} alt="Smiley face" height="22" width="22" />
                                        <span style={{ paddingLeft: '10px' }}>Total Expiration ({renewalExpiredCount.total + renewalTodayCount.total + renewalUpcomingCount.total})</span>
                                    </span>
                                }
                                    headStyle={{
                                        backgroundColor: '#6d6d6d',
                                        color: 'white',
                                        minHeight: '11px',
                                        fontSize: '17px'
                                    }}
                                    bodyStyle={{ padding: '34px' }} bordered={false}
                                    style={{ height: '145px', marginTop: '15px' }}>
                                    <Row>
                                        <Col span={8}>
                                            <Row>
                                                <Col>
                                                    <div className={styles.followupsVisa}>OverDue</div>
                                                    <a href='/agreement-management?type=overdue' target='_blank'>
                                                        <div className={styles.followupsNumber} style={{ color: '#8ac545' }}>
                                                            {renewalExpiredCount.total}
                                                        </div>
                                                    </a>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={8}>
                                            <Row>
                                                <Col>
                                                    <div className={styles.followupsVisa}>Today</div>
                                                    <a href='/agreement-management?type=today' target='_blank'>
                                                        <div className={styles.followupsNumber} style={{ color: '#8ac545' }}>
                                                            {renewalTodayCount.total}
                                                        </div>
                                                    </a>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={8}>
                                            <Row>
                                                <Col>
                                                    <div className={styles.followupsVisa}>Upcoming (In Next 30 Days)</div>
                                                    <a href='/agreement-management?type=upcoming' target='_blank'>
                                                        <div className={styles.followupsNumber} style={{ color: '#8ac545' }}>
                                                            {renewalUpcomingCount.total}
                                                        </div>
                                                    </a>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </RightsWrapper>
                    <RightsWrapper myRight={"relationshipCountUniversityPartnership.view"}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Card title={
                                    <span>
                                        <img src={followUpsIcon} alt="Smiley face" height="22" width="22" />
                                        <span style={{ paddingLeft: '10px' }}>Count According to University Partnership</span>
                                    </span>
                                }
                                    headStyle={{
                                        backgroundColor: '#6d6d6d',
                                        color: 'white',
                                        minHeight: '11px',
                                        fontSize: '17px'
                                    }}
                                    bodyStyle={{ padding: '34px' }} bordered={false}
                                    style={{ minHeight: '145px', marginTop: '15px' }}>
                                    <Row>
                                        {
                                            universityPartnerShipCount.data ?
                                                universityPartnerShipCount.data.map((university, index) => {
                                                    if (university._id) {
                                                        return (
                                                            <Col key={index} style={{ marginBottom: '30px' }} span={8}>
                                                                <Row>
                                                                    <Col>
                                                                        <div className={styles.followupsVisa}>{university._id ? university._id : 'Not Assigned'}</div>
                                                                        <a href={`/agreement-management?patnerShiptype=${university._id}`} target='_blank'>
                                                                            <div className={styles.followupsNumber} style={{ color: '#8ac545' }}>
                                                                                {university.count}
                                                                            </div>
                                                                        </a>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        )
                                                    }
                                                })
                                                : null
                                        }
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </RightsWrapper>
                    <RightsWrapper myRight={"relationshipCountUniversityConsortium.view"}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Card title={
                                    <span>
                                        <img src={followUpsIcon} alt="Smiley face" height="22" width="22" />
                                        <span style={{ paddingLeft: '10px' }}>Count According to University Consortium</span>
                                    </span>
                                }
                                    headStyle={{
                                        backgroundColor: '#6d6d6d',
                                        color: 'white',
                                        minHeight: '11px',
                                        fontSize: '17px'
                                    }}
                                    bodyStyle={{ padding: '34px' }} bordered={false}
                                    style={{ minHeight: '145px', marginTop: '15px' }}>
                                    <Row>
                                        {
                                            universityConsortiumIdCounts.data ?
                                                universityConsortiumIdCounts.data.map((university, index) => {
                                                    return (
                                                        <Col key={index} style={{ marginBottom: '30px' }} span={8}>
                                                            <Row>
                                                                <Col>
                                                                    <div className={styles.followupsVisa}>{university.consortiumName == 'NA' ? 'Not Assigned' : university.consortiumName}</div>
                                                                    <a href={`/agreement-management?consortiumId=${university.consortiumId}`} target='_blank'>
                                                                        <div className={styles.followupsNumber} style={{ color: '#8ac545' }}>
                                                                            {university.count}
                                                                        </div>
                                                                    </a>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    )
                                                })
                                                : null
                                        }
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </RightsWrapper>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (RelationShipManagerDashboard)
